/**
 * created by wang lei
 拆分成列页面
 *
 */
import React, {Component} from 'react';
import splitColumn from './splitColumn.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class SplitColumn extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            SplitColumn:false
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let SplitColumn = this.props.editor.queryCommandState("splittocols")
        this.setState({SplitColumn: SplitColumn === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let SplitColumn = this.props.editor.queryCommandState("splittocols")
        this.setState({SplitColumn: SplitColumn === 0});
    }

    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.SplitColumn ? "1":"0.3"}}>
                <img className={"editor-splittoCols-tool-btn"} src={splitColumn}
                     onClick={()=>this.props.editor.execCommand("splittocols")}/>
                {this.state.SplitColumn ? <style>{`
                .editor-splittoCols-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-splittoCols-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-splittoCols-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-splittoCols-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-splittoCols-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-splittoCols-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}